export const en = {
  translation: {
    hello: "Hello",
  },

  attributes: {
    children: {
      gender: {
        male: "Male",
        female: "Female",
        other: "Other",
      },
      ageRange: {
        under_two: "Under 2 years (At time of registration)",
        two_to_three: "2-3 years (At time of registration)",
        three_to_four: "3-4 years (At time of registration)",
        four_to_five: "4-5 years (At time of registration)",
        six_or_older: "6 years or older (At time of registration)",
      }
    }
  },

  charts: {
    wordsLearned: {
      words_one: "{{count}} word",
      words_other: "{{count}} words",
      title: "Number of Words Learned",
      description: "Number of words learned per week",
      xAxisLabel: "Week",
      yAxisLabel: "Number of Words",
    },
    timePlayed: {
      minutes_one: "{{count}} minute",
      minutes_other: "{{count}} minutes",
      title: "Time Played",
      description: "Total time played per week",
      xAxisLabel: "Week",
      yAxisLabel: "Time Played",
    },
    songPlays: {
      title: "Song Plays",
      description: "Number of times a song was played",
      xAxisLabel: "Song",
      yAxisLabel: "Number of Plays",
    },
  }
} as const;
